// extracted by mini-css-extract-plugin
export var printerCard = "_af-1";
export var printerCardConfigured = "_af-2";
export var printerCardError = "_af-3";
export var printerCardsContainer = "_af-0";
export var printerIcon = "_af-8";
export var printerIconConfigured = "_af-5";
export var printerIconContainer = "_af-4";
export var printerIconError = "_af-6";
export var printerIconUnconfigured = "_af-7";
export var workstationsTableCard = "_af-9";